import { withStyle } from 'styletron-react'
import FormFieldRoot from '../formfield/styled'

const NativeSelectRoot = withStyle(FormFieldRoot, { width: '100%' })
export default NativeSelectRoot
